import { TConsumerItem } from '../../../types/data';

export const convertItemsToListSelect = (items?: Array<TConsumerItem>, currentIso?: string): Array<TConsumerItem> =>
    Array.isArray(items) ? items?.map?.((item) => convertItemToListSelect(item, currentIso) as TConsumerItem) : [];
const convertItemToListSelect = (item: TConsumerItem, currentIso?: string): TConsumerItem => {
    return {
        ...item,
        icon: item.countryIso,
        selected: item.countryIso?.toLowerCase?.() === currentIso?.toLowerCase?.(),
    };
};
